import { render, staticRenderFns } from "./specialCatalogueList.vue?vue&type=template&id=47b79a1e&scoped=true"
import script from "./specialCatalogueList.vue?vue&type=script&lang=js"
export * from "./specialCatalogueList.vue?vue&type=script&lang=js"
import style0 from "./specialCatalogueList.vue?vue&type=style&index=0&id=47b79a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b79a1e",
  null
  
)

export default component.exports